import React, { useEffect, useMemo } from 'react';
import DepartmentDetail from './DepartmentDetails/DepartmentDetail.jsx';
import { Spinner } from '../../../common/index.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash';
import { useGetDepartmentQuery } from '../../../../redux/services/departments.jsx';

const DepartmentsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slug } = useParams();

  const initialDepartment = useMemo(() => {
    const departmentCode = window?.initData?.department?.code;
    const departmentCodeEn = window?.initData?.department?.code_en;

    // if departmentCode is not undefined AND slug matches the Slovak or English code
    // return department from window.initData
    // otherwise return undefined => fetching is triggered automatically
    return !isUndefined(departmentCode) &&
      (slug === departmentCode || slug === departmentCodeEn)
      ? window?.initData?.department
      : undefined;
  }, [slug]);

  // For google indexing (google bot came on page and index it for results in search)
  // We are serving data first time without calling this fetch asynchronously
  // It will be fetched in SeoController and served via homepage.blade.php, so we can use it here
  const { data: fetchedDepartment } = useGetDepartmentQuery(slug, {
    skip: !isUndefined(initialDepartment),
  });

  const department = initialDepartment ?? fetchedDepartment;

  useEffect(() => {
    if (isUndefined(department)) {
      return;
    }

    if (department?.active === 0) {
      notification.info({
        message: t('Zvolené pracovisko nie je aktívne.'),
      });
      navigate(routes.homePage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [department]);

  if (isUndefined(department)) {
    return <Spinner />;
  }

  return <DepartmentDetail department={department} />;
};

export default DepartmentsPage;
